/** A camera with a line through it. Used wherever an offline camera is shown. */
export function OfflineCameraIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 3l18 18M10.5 5.5A9 9 0 0121 12M6 8a12 12 0 00-3 4m4.5 3.5a5 5 0 016-1M12 19h.01"
      />
    </svg>
  )
}
